module.exports = {
  title: 'RuneScape Stats Redux',
  description: `
    To help myself deep-dive into learning React, I decided to remake my original RuneScape stats with React+Redux+Saga as well as making it feel a little more user friendly.
    There's a few tiny features missing (mainly polling), but I wasn't too focused on having a 1:1 remake.
  `,
  tags: ['CSS', 'Design', 'React', 'Redux', 'Redux-Saga', 'RuneScape API',],
  images: [require('./images/1.png'), require('./images/2.png'), require('./images/3.png'),],
  url: 'https://rs.christieman.com/react/',
};



// WEBPACK FOOTER //
// ./src/data/works/runescaperedux/index.js